import { render } from "./LinkerWord.vue?vue&type=template&id=db8ffdf2&ts=true"
import script from "./LinkerWord.vue?vue&type=script&lang=ts"
export * from "./LinkerWord.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__